export const MOBILE_TYPE = 'MOBILE';
export const FIXED_LINE_OR_MOBILE_TYPE = 'FIXED_LINE_OR_MOBILE';
export const FIXED_LINE_TYPE = 'FIXED_LINE';
export const TOLL_FREE_TYPE = 'TOLL_FREE';
